<odx-form-field i18n-label="@@newProject.projectForm.label.opportunityLink" label="Opportunity-Link">
  <input
    formControlName="opportunityLink"
    odxFormFieldControl
    i18n-placeholder="@@newProject.projectForm.placeholder.opportunityLink"
    placeholder="Opportunity-Link"
    [readonly]="isReadonly"
    [required]="required"
    data-testid="projectForm.opportunityLink"
  />
</odx-form-field>
